import { GridCellProps } from '@progress/kendo-react-grid';
import FailedIcon from 'src/assets/icons/FailedIcon';
import Button from 'src/components/design-system/Button';
import CircularIconButton from 'src/components/design-system/CircularIconButton';
import GridCellBase from 'src/components/GridCellBase';
import useInvoiceScanManager from 'src/hooks/useInvoiceScanManager';

const StatusOcrCell = (props: GridCellProps) => {
  const { openOcrReviewModal, handleCellClick } = useInvoiceScanManager();

  const field = props.field || '';
  const value = props.dataItem[field];

  const handleReviewClick = () => {
    handleCellClick(props.dataItem.attachId);
    openOcrReviewModal(props.dataItem.attachId);
  };

  const handleClick = () => {
    handleCellClick(props.dataItem.attachId);
  };

  const newValue = value === 'In Progress' ? 'Scan in Progress' : value;

  return (
    <GridCellBase
      {...props}
      rowSelectionEnabled={false}
      onClick={handleClick}
      className="!p-0 relative"
      title={newValue}
    >
      {newValue === 'Needs Review' ? (
        <div className="flex items-center flex-row justify-center absolute inset-0">
          <Button size="sm" color="secondary" onClick={handleReviewClick}>
            <span className="text-[13px]">{newValue}</span>
          </Button>
        </div>
      ) : (
        <div className="flex flex-row gap-2 items-center justify-center">
          {newValue === 'Failed' && (
            <CircularIconButton className="focus-visible:ring-2 focus-visible:ring-black focus-visible:border-black">
            <FailedIcon />
          </CircularIconButton>
          )}
          {newValue}
        </div>
      )}
    </GridCellBase>
  );
};

export default StatusOcrCell;
